import axios from 'axios'

let jumpFlag = true

const action = function (url, method, dat, opt) {
	const data = dat || {}
	const option = opt || {}
	option.headers = option.headers || {}
	window.sessionStorage.setItem('lang',"zh-CN")
	/*option.headers['SfopenReferer'] ='99999988'*/
	/*option.headers['lang'] = window.sessionStorage.getItem('lang')*/
	option.headers['cr-service'] = encodeURIComponent(process.env._FRONTURL)
	option.headers['cr-referer'] = 'cr-web'
	option.withCredentials = true
	const promise = new Promise((resolve, reject) => {
		let req
		if (/^p/.test(method)) {
			req = axios[method](url, data, option)
		} else {
			option.params = data
			req = axios[method](url, option)
		}
		req.then((response) => {//NOSONAR
			if(!response) {return}
			let tmp = response.data
			resolve(tmp)

		}, (err) => {
			reject(err)
		})

	})
	return promise
}

const httpExt = {
	put(url, data, option) {
		return action(url, 'put', data, option)
	},
	putForm(url, data, option) {
		const opt = option || {}
		opt.headers = {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		}
		opt.emulateJSON = true
		return action(url, 'put', data, opt)
	},
	post(url, data, option) {
		return action(url, 'post', data, option)
	},
	postJson(url, data, option) {
		return action(url, 'post', data, option)
	},
	postForm(url, data, option) {
		const opt = option || {}
		opt.headers = {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		}
		opt.emulateJSON = true
		return action(url, 'post', data, opt)
	},
	get(url, data, option) {
		/**添加时间戳,防止ie有缓存*/
		const data2 = data ? Object.assign(data, { time: new Date().getTime() }) : data;
		
		return action(url, 'get', data2, option)
	},
	delete(url, data, option) {
		return action(url, 'delete', data, option)
	}
}

export default {
	install(Vue) {
		Vue.prototype.$axios = axios
		Vue.prototype.$httpExt = function () {
			return httpExt
		}
	}
}


// WEBPACK FOOTER //
// ./src/comm/js/axiosExt.vue.plugin.js